import React from 'react';

interface SiteContextProperties {
  amp?: boolean;
  board?: string;
  hasJobsInLanding?: boolean;
  hasLocalNews?: boolean;
  hasNews?: boolean;
  jobsComplete?: boolean;
  jobsLocale?: string;
  lite?: boolean;
  locale?: string;
  newsboard?: string;
  origin?: string;
  prefix?: string;
  url?: string;
  production?: boolean;
}

const SiteContext = React.createContext<SiteContextProperties>({});

export type { SiteContextProperties };
export default SiteContext;
